export const filters = () => ({
        price: [Infinity, 0],
        duration: [],
        dates: [],
        startTimes: [],
        types: [],
        themes: [],
        categories: [],
        name: null,
        shortDescription: null,
        wishlist: [],
        supplierName: [],
    }),
    searchRequest = () => ({
        convertToCurrency: null,
        cityId: null,
        countryId: null,
        startDate: null,
        endDate: null,
        adults: 1,
        childrenAges: [],
        partialResponse: true,
    }),
    searchResponse = () => ({
        filters: filters(),
        product: [],
    })
